<script>
	import { getContext } from 'svelte'
	import OwnshipMarker from './ownshipMarker'

	const flight = getContext('flight')
	const marker = flight.getHandler(OwnshipMarker)
</script>